var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { BlocksElement } from '../../BlocksElement';
import styles from '../icon.styles';
/**
 * ArrowTriangularRight component
 * @csspart base- The component's base wrapper
 */
export class BlocksIconArrowTriangularRight extends BlocksElement {
    static { this.styles = styles; }
    connectedCallback() {
        super.connectedCallback();
        this.classList.add('cat-icon');
    }
    render() {
        const componentClassName = this.componentClassNames('cat-c-icon cat-c-icon-bi-directional', {
            'cat-c-icon--sm': this.size === 'sm',
            'cat-c-icon--lg': this.size === 'lg',
            'cat-c-icon--xl': this.size === 'xl',
            'cat-c-icon--content-strong': this.color === 'content-strong',
            'cat-c-icon--knockout': this.color === 'knockout',
            'cat-c-icon--knockout-brand': this.color === 'knockout-brand',
            'cat-c-icon--information': this.color === 'information',
            'cat-c-icon--success': this.color === 'success',
            'cat-c-icon--warning': this.color === 'warning',
            'cat-c-icon--error': this.color === 'error'
        });
        return html `
      <span part="base" class="${componentClassName}" role="presentation">
        <svg
          aria-hidden="${!this.iconTitle}"
          aria-label="${ifDefined(this.iconTitle)}"
          role="${this.iconTitle && 'img'}"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M8.80361 4.16738C8.64018 4.00396 8.3944 3.95507 8.18087 4.04351C7.96735 4.13196 7.82812 4.34032 7.82812 4.57144V19.4285C7.82812 19.6596 7.96735 19.8681 8.18087 19.9565C8.3944 20.0449 8.64018 19.9961 8.80361 19.8326L15.8269 12.8093C15.9349 12.706 16.0212 12.5822 16.0805 12.445C16.1413 12.3045 16.1727 12.1531 16.1727 12C16.1727 11.8469 16.1413 11.6955 16.0805 11.555C16.0212 11.4178 15.9349 11.294 15.8269 11.1907L8.80361 4.16738Z"
          />
        </svg>
      </span>
    `;
    }
}
__decorate([
    property({ type: String })
], BlocksIconArrowTriangularRight.prototype, "color", void 0);
__decorate([
    property({ type: String })
], BlocksIconArrowTriangularRight.prototype, "iconTitle", void 0);
__decorate([
    property({ type: String })
], BlocksIconArrowTriangularRight.prototype, "size", void 0);
if (customElements.get('cat-icon-arrow-triangular-right') === undefined) {
    customElements.define('cat-icon-arrow-triangular-right', BlocksIconArrowTriangularRight);
}
